import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import ActiveRadioButtonCircle from '../Icons/ActiveRadioButtonCircle';
import InActiveRadioButtonCircle from '../Icons/InActiveRadioButtonCircle';
import { FieldErrorInfo } from './FormField';

interface CustomInlineRectangularRadioFieldGroupProps {
  children: React.ReactNode;
  name: string;
  label?: string;
}

export const CustomInlineRectangularRadioFieldGroup: React.FC<
  CustomInlineRectangularRadioFieldGroupProps
> = ({ children, name, label }) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <RadioGroupWrapper>
      {label && <InputLabel>{label}</InputLabel>}
      <RadioGroup>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(child, {
            ...child.props,
          });
          // }
        })}
      </RadioGroup>

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroupWrapper>
  );
};

export interface CustomRectangularRadioProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
}

export const CustomRectangularRadio: React.FC<CustomRectangularRadioProps> = ({
  children,
  className,
  ...props
}) => {
  const [field] = useField({ ...props, type: 'radio' });

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} />
        <RadioItemDiv>
          <RadioItemActiveIcon className='active'>
            <ActiveRadioButtonCircle />
          </RadioItemActiveIcon>
          <RadioItemInactiveIcon className='inactive'>
            <InActiveRadioButtonCircle />
          </RadioItemInactiveIcon>
          {children}
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const RadioItemDiv = styled.div`
  display: flex;
  gap: 12px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 10px 28px;
  width: 100%;
  border-radius: 6px;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  height: 40px;
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 10px;
  color: black;
  user-select: none;
`;
const RadioItemActiveIcon = styled.div`
  display: none;
`;

const RadioItemInactiveIcon = styled.div``;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
  }

  & > label input[type='radio']:checked ~ div > .active {
    display: block;
  }

  & > label input[type='radio']:checked ~ div > .inactive {
    display: none;
  }

  & > label input[type='radio']:checked ~ div {
    border: 1px solid ${({ theme }) => theme.palette.logiratePrimary};
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* border: 1px solid red; */
  padding: 0px;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 12px;
  /* border: 1px solid blue; */

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)`
  margin-top: 0px;
`;
